import { createAsyncThunk } from '@reduxjs/toolkit';
import { getInvestors } from '@/api/custom';
import type { RootState } from '@/store';
import { buildInvestorsContextKey } from './investorsContext';

export type FetchInvestorsAllArg = {
  contextKey?: string | null;
};

export const fetchInvestorsAllThunk = createAsyncThunk(
  'investors/fetchAll',
  async (arg: FetchInvestorsAllArg | undefined, { getState }) => {
    const state = getState() as RootState;
    const contextKey = arg?.contextKey ?? buildInvestorsContextKey(state.userinfo.user);

    const limit = 1024;
    let offset = 0;
    let response = await getInvestors({ limit, offset });
    const investors = [...response];
    while (response.length === limit) {
      offset += limit;
      response = await getInvestors({ limit, offset });
      investors.push(...response);
    }
    return { investors, contextKey };
  },
);
